export const MIN_NUMBER_INPUT_VALUE = 0;
export const DEFAULT_BORROWING_PERIOD = 14;
export const DEFAULT_EXTENSION_PERIOD = 7;
